import React from 'react'
import { AppBar, Box, Toolbar, Typography } from '@mui/material'
import SettingButton from './SettingButton'
import ManualButton from './ManualButton'

const Topbar = ({ className }) => {
  return (
    <AppBar position="static" className={className}>
      <Toolbar>
        <Typography variant="h6" className="app-name">
          Yqui
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <SettingButton />
        <ManualButton />
      </Toolbar>
    </AppBar>
  )
}

export default Topbar
